export class ReportCategoryModel {
  Name: string;
  enumReportCategoryID: string;
}
